import { createSelector } from '@reduxjs/toolkit'

import { NotificationsState } from '@/ducks/notifications/slices/notification.slice'

const selectDashboard = (state: { notifications: NotificationsState }) =>
  state.notifications

export const selectNotifications = createSelector(
  selectDashboard,
  notifications => notifications.notifications
)

export const selectSystemNotifications = createSelector(
  selectDashboard,
  notifications => notifications.system
)

export const selectNewOrdersNotifications = createSelector(
  selectDashboard,
  notifications => notifications.newOrders
)
